export const REQUESTS_ADD = 'REQUESTS_ADD' as const;
export const REQUESTS_LOADING = 'REQUESTS_LOADING' as const;
export const REQUESTS_ADD_ONE = 'REQUESTS_ADD_ONE' as const;
export const REQUESTS_FAILURE = 'REQUESTS_FAILURE' as const;
export const REQUESTS_TOTAL_PAGES = 'REQUESTS_TOTAL_PAGES' as const;
export const REQUEST_DATA = 'REQUEST_DATA' as const;
export const REQUEST_STATUS_DATA = 'REQUEST_STATUS_DATA' as const;
export const REQUEST_UPDATING = 'REQUEST_UPDATING' as const;
export const REQUEST_UPDATE = 'REQUEST_UPDATE' as const;
export const REQUEST_RESET = 'REQUEST_RESET' as const;
export const DOWNLOADING_FILE = 'DOWNLOADING_FILE' as const;
